<template>
  <gkFormText
    class="password-text"
    validity
    :group="group"
    :field="field"
    :trigger="trigger"
    :type="type"
    :size="size"
    :color="color"
    :placeholder="placeholder"
    :length="length"
    :rule="mergeRule"
    :disabled="disabled"
    :customRule="customRule"
    v-model="currentValue"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <!-- <div slot="end" class="action-icon" @click="handleChange">
      <Icon :class='type==="text" ? null : "show"' :code="type==='text' ? '&#xe684;' : '&#xe685;'" />
    </div> -->
  </gkFormText>
</template>

<script>
import VueTypes from 'vue-types'

import gkFormText from 'gkui/form/FormText'
import formProps from 'gkui/form/form.props'
import validityProps from 'gkui/form/validity.props'

// import Icon from '../Icon'

export default {
  name: 'password',
  components: {
    gkFormText
    // Icon
  },
  props: Object.assign({}, formProps, validityProps, {
    field: VueTypes.string.def('password'),
    // 限制输入长度，默认 6-16 为密码表单
    placeholder: VueTypes.string.def('请输入密码'),
    length: VueTypes.number.def(16),
    rule: VueTypes.oneOfType([String, Array]).def(['required', {password: '请输入正确的密码(6-16位)'}])
  }),
  data () {
    return {
      type: 'password',
      currentValue: this.value
    }
  },
  computed: {
    mergeRule () {
      return this.rule.map(item => {
        if (item === 'required') {
          return {
            required: this.placeholder
          }
        }

        return item
      })
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    }
  },
  methods: {
    handleChange () {
      this.type = this.type === 'password' ? 'text' : 'password'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';
.password-text {
  height: 42px;
}
.action-icon {
  position: relative;
  width: 42px;
  color: #C0C0C0;
  cursor: pointer;
  user-select: none;

  & .iconfont {
    position: absolute; right: 14px; top: 16px;
    line-height: 1;
    font-size: 22px;
    transform: scale(0.5); transform-origin: right top;

    @include mobile {
      right: 2px; top: 17px;
    }

    &.show {
      right: 14px; top: 18px;
      font-size: 14px;

      @include mobile {
        right: 2px; top: 19px;
      }
    }
  }
}
</style>
